import * as React from "react"
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { cn } from "@/lib/utils"
import { Building2, MapPin, Box, Scan, ClipboardList, User, Bell, LayoutDashboard } from "lucide-react"
import { useNotifications } from "@/hooks/useNotifications"

interface MobileHeaderProps {
  onSignOut?: () => void;
}

export function MobileHeader({ onSignOut }: MobileHeaderProps) {
  const location = useLocation()
  const { t } = useTranslation()
  const { todayRecords, todayReminders } = useNotifications()
  
  return (
    <header className="md:hidden fixed bottom-0 left-0 right-0 z-50 border-t bg-white/80 backdrop-blur-lg">
      <nav className="h-16">
        <ul className="h-full grid grid-cols-7 items-center">
          <li>
            <Link 
              to="/"
              className={cn(
                "h-full flex flex-col items-center justify-center space-y-1",
                location.pathname === "/" 
                  ? "text-apple-blue"
                  : "text-gray-600"
              )}
            >
              <LayoutDashboard className="h-5 w-5" />
              <span className="text-xs">{t('menu.overview')}</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/scan"
              className={cn(
                "h-full flex flex-col items-center justify-center space-y-1",
                location.pathname === "/scan" 
                  ? "text-apple-blue"
                  : "text-gray-600"
              )}
            >
              <Scan className="h-5 w-5" />
              <span className="text-xs">{t('menu.scan')}</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/records"
              className={cn(
                "h-full flex flex-col items-center justify-center space-y-1",
                location.pathname === "/records" 
                  ? "text-apple-blue"
                  : "text-gray-600"
              )}
            >
              <div className="relative">
                <ClipboardList className="h-5 w-5" />
                {todayRecords > 0 && (
                  <span className="absolute -top-1 -right-1 h-2 w-2 bg-red-500 rounded-full" />
                )}
              </div>
              <span className="text-xs">{t('menu.records')}</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/assets"
              className={cn(
                "h-full flex flex-col items-center justify-center space-y-1",
                location.pathname === "/assets" 
                  ? "text-apple-blue"
                  : "text-gray-600"
              )}
            >
              <Box className="h-5 w-5" />
              <span className="text-xs">{t('menu.assets')}</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/places"
              className={cn(
                "h-full flex flex-col items-center justify-center space-y-1",
                location.pathname === "/places" 
                  ? "text-apple-blue"
                  : "text-gray-600"
              )}
            >
              <MapPin className="h-5 w-5" />
              <span className="text-xs">{t('menu.places')}</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/companies"
              className={cn(
                "h-full flex flex-col items-center justify-center space-y-1",
                location.pathname === "/companies" 
                  ? "text-apple-blue"
                  : "text-gray-600"
              )}
            >
              <Building2 className="h-5 w-5" />
              <span className="text-xs">{t('menu.companies')}</span>
            </Link>
          </li>
          <li>
            <Link 
              to="/profile"
              className={cn(
                "h-full flex flex-col items-center justify-center space-y-1",
                location.pathname === "/profile" 
                  ? "text-apple-blue"
                  : "text-gray-600"
              )}
            >
              <User className="h-5 w-5" />
              <span className="text-xs">{t('menu.profile')}</span>
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  )
} 